import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import DialogTitle from '@mui/material/DialogTitle';
import CustomTextField from '../../Components/TextField';
import { FormHelperText, Chip, Button, IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import * as yup from 'yup';
import { useFormik } from 'formik';

import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/system';

import "./style.css"

import { useErrorHandler } from '../../hooks';
import useToggle from '../../hooks/use-toggle';
import { ResetPasswordAction } from '../../Redux/Actions/AuthActions';

const Resetpassword = ({ open, setOpen }) => {
    const [visiblePassword, setVisiblePassword] = useToggle(true);
    const [visibleConfirmPassword, setVisibleConfirmPassword] = useToggle(true);
    const dispatch = useDispatch();
    const { setMsgConfig } = useErrorHandler();
    const {user} = useSelector((state) => state.Auth)
    const token = user.token
    const formik = useFormik({
        initialValues: {
            password: '',
            confirmPassword: '',
        },
        enableReinitialize: true,

        validationSchema: yup.object({
            password: yup
                .string()
                .required('Please Enter Password')
                .min(3, 'characters must be more than 3')
                .matches(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/,
                    'Password must have 8 characters,1 special character,1 UpperCase letter,1 LowerCase letter'
                ),

            confirmPassword: yup
                .string()
                .required()
                .oneOf([yup.ref('password'), null], 'Password Must Match'),
        }),
        onSubmit: (values) => {
            let payload = {
                token: token,
                new_password: formik.values.password,
                confirm_password: formik.values.confirmPassword,
              };
              dispatch(ResetPasswordAction(payload));              
            setMsgConfig({
                alertOpen: true,
                message: 'Password Change successfully!',
                severity: 'success',
                autoHideDuration: 2000,
            });
            setOpen(!open);            
        },
    });

    const handleClose = () => {
        setOpen(!open);
    };
    return (
        <>
            <Dialog open={open} onClose={handleClose} className="reset-modal">
                <DialogTitle>Reset Password</DialogTitle>
                <DialogContent>
                    <Box className="input form-control-label">
                        <CustomTextField                            
                            fieldType="simpleTextInput"
                            type={visiblePassword ? 'password' : 'text'}                            
                            fullWidth
                            variant="Outlined"                            
                            name="password"
                            value={formik.values.password}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder={'Enter your Password'}
                            error={
                                formik.touched.password && formik.errors.password
                                    ? true
                                    : false
                            }
                        />
                        <IconButton className="reset-toggle-eye" onClick={setVisiblePassword}>
                            {visiblePassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                        </IconButton>
                        {formik.touched.password &&
                            formik.errors.password && (
                                <FormHelperText className='error_message'>
                                    {formik.errors.password}
                                </FormHelperText>
                            )}
                    </Box>
                    <Box className="input form-control-label" sx={{my: 3}}>
                        <CustomTextField                        
                            fieldType="simpleTextInput"
                            type={visibleConfirmPassword ? 'password' : 'text'}                            
                            fullWidth     
                            variant="Outlined"                       
                            name="confirmPassword"
                            value={formik.values.confirmPassword}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            placeholder={'Re-Enter Password'}
                            error={
                                formik.touched.confirmPassword &&
                                    formik.errors.confirmPassword
                                    ? true
                                    : false
                            }
                        />
                        <IconButton
                            className="reset-toggle-eye"
                            onClick={setVisibleConfirmPassword}
                        >
                            {visibleConfirmPassword ? (
                                <VisibilityIcon />
                            ) : (
                                <VisibilityOffIcon />
                            )}
                        </IconButton>
                        {formik.touched.confirmPassword &&
                            formik.errors.confirmPassword && (
                                <FormHelperText className='error_message'>
                                    {formik.errors.confirmPassword}
                                </FormHelperText>
                            )}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button className="btn-dark" variant="outlined" onClick={handleClose}>
                        Cancel
                    </Button>

                    <Button
                        className="btn-dark"
                        variant="contained"
                        onClick={formik.handleSubmit}
                    >
                        RESET PASSWORD
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default Resetpassword
